import api from '../api';

// Wallet Management API endpoints
export const walletAPI = {
  // Get wallet status
  getWalletStatus: (userId) => 
    api.get(`/wallet/status/${userId}`),

  // Setup wallet (create customer and setup intent)
  setupWallet: (userId) => 
    api.post('/wallet/setup', { userId }),

  // Complete wallet setup after payment method is added
  completeWalletSetup: (userId, setupIntentId) => 
    api.post('/wallet/complete-setup', { userId, setupIntentId }),

  // Update user KYC information (BVN/NIN for Flutterwave virtual accounts)
  updateUserKyc: (userId, kycData) =>
    api.put(`/wallet/kyc/${userId}`, kycData),

  // Setup collector account
  setupCollectorAccount: (userId, country = 'US') => 
    api.post('/wallet/collector-setup', { userId, country }),

  // Complete collector onboarding
  completeCollectorOnboarding: (userId) => 
    api.post('/wallet/complete-collector-onboarding', { userId }),

  // Remove payment method
  removePaymentMethod: (paymentMethodId) => 
    api.delete(`/wallet/payment-method/${paymentMethodId}`),

  // Setup Flutterwave withdrawal account
  setupFlutterwaveWithdrawal: (userId, accountName, accountNumber, bankCode, bankName) =>
    api.post('/wallet/flutterwave-withdrawal-setup', { 
      userId, 
      accountName, 
      accountNumber, 
      bankCode,
      bankName
    }),

  // Remove Flutterwave card authorization
  removeFlutterwaveCard: (userId) =>
    api.delete('/wallet/flutterwave-card', { data: { userId } }),

  // Transaction history (Flutterwave users)
  getTransactionHistory: (userId, params = {}) =>
    api.get(`/wallet/transactions/${userId}`, { params }),

  // Withdraw wallet balance to linked bank account
  withdrawWalletBalance: (userId, amount) =>
    api.post('/wallet/withdraw', { userId, amount }),

};

// Flutterwave API endpoints (limited UI helpers)
export const flutterwaveAPI = {
  // List banks
  listBanks: (country = 'NG') =>
    api.get('/flutterwave/banks', { params: { country } }),

  // Resolve bank account
  resolveAccount: (accountNumber, bankCode) =>
    api.post('/flutterwave/account/resolve', { account_number: accountNumber, bank_code: bankCode }),

  // Initiate transfer (manual payout if enabled)
  initiateTransfer: (payload) =>
    api.post('/flutterwave/transfer', payload)
};

// Stripe API endpoints
export const stripeAPI = {
  // Create Stripe customer
  createCustomer: (userId) => 
    api.post('/stripe/customer', { userId }),

  // Create connected account
  createConnectedAccount: (userId, country = 'US') => 
    api.post('/stripe/account', { userId, country }),

  // Process contributions
  processContributions: (cycleId, contributions) => 
    api.post('/stripe/contribute', { cycleId, contributions }),

  // Get account status
  getAccountStatus: (userId) => 
    api.get(`/stripe/account-status/${userId}`),

  // Create setup intent
  createSetupIntent: (userId) => 
    api.post('/stripe/setup-intent', { userId }),

  // Complete wallet setup (Stripe version)
  completeWalletSetupStripe: (userId, setupIntentId) => 
    api.post('/stripe/complete-wallet-setup', { userId, setupIntentId }),

  // Get payment methods
  getPaymentMethods: (userId) => 
    api.get(`/stripe/payment-methods/${userId}`),

  // Get account balance
  getAccountBalance: (userId) => 
    api.get(`/stripe/balance/${userId}`),

  // Get balance transactions
  getBalanceTransactions: (userId, params = {}) => 
    api.get(`/stripe/transactions/${userId}`, { params }),

  // Get wallet summary (combined database and Stripe data)
  getWalletSummary: (userId) => 
    api.get(`/stripe/wallet-summary/${userId}`),

  // Check and update onboarding status manually
  checkOnboardingStatus: (userId) => 
    api.post(`/stripe/check-onboarding/${userId}`),
};

// Stripe Thrift API endpoints
export const stripeThriftAPI = {
  // Start thrift cycle
  startThriftCycle: (thriftId) => 
    api.post('/stripe-thrift/start-cycle', { thriftId }),

  // Complete thrift cycle
  completeThriftCycle: (cycleId) => 
    api.post('/stripe-thrift/complete-cycle', { cycleId }),

  // Get cycle status
  getCycleStatus: (cycleId) => 
    api.get(`/stripe-thrift/cycle-status/${cycleId}`),

  // Get user payment details (bank details, etc.)
  getPaymentDetails: (userId) => 
    api.get(`/users/${userId}/payment-details`),
};
